import './styles.scss';

import { useEffect, useState } from 'react';

import LostAndFoundFormHistoryTableColumns from '@/features/LostAndFoundHistory/components/LostAndFoundHistoryForm/LostAndFoundFormHistoryTable/LostAndFoundFormHistoryTableColumns';
import LostAndFoundFormHistoryTableRow from '@/features/LostAndFoundHistory/components/LostAndFoundHistoryForm/LostAndFoundFormHistoryTable/LostAndFoundFormHistoryTableRow';
import { LostAndFoundHistoryFormDefinitions } from '../types';
import { LostAndFoundHistoryRow } from '@/features/LostAndFoundHistory';
import Provider from '@/common/Provider';
import SimpleTable from '@/components/SimpleTable';
import { refetchLostAndFoundIssueWithDocuments } from '@/features/LostAndFoundHistory/api/services/searchLostAndFoundIssue';

const LostAndFoundFormHistoryTable = ({
  onEditLostAndFound,
  id,
  driverFirstName,
  driverLastName,
  vehicleTrackingId,
}: {
  onEditLostAndFound?: (accident: LostAndFoundHistoryFormDefinitions.Value) => void;
  id: string;
  driverFirstName: string;
  driverLastName: string;
  vehicleTrackingId: string;
}): JSX.Element => {
  const [{ loading, data }, setState] = useState({ loading: false, data: new Map() });
  const getHistory = async (id: string): Promise<void> => {
    try {
      setState((prevState) => ({ ...prevState, loading: true }));
      const res = await refetchLostAndFoundIssueWithDocuments([{ id }]);
      setState((current) => {
        const data = new Map<string, LostAndFoundHistoryRow>(res.rows.map((issue) => [issue.id, issue]));
        return { ...current, data };
      });
    } catch (err) {
      console.error('Error getting history:', err);
    } finally {
      setState((prevState) => ({ ...prevState, loading: false }));
    }
  };

  useEffect((): void => {
    console.log(id);
    if (!id) return;
    getHistory(id);
  }, [id]);

  return (
    <Provider value={{ data, driverFirstName, driverLastName, vehicleTrackingId }} methods={() => ({ onEditLostAndFound })}>
      <SimpleTable
        className="LostAndFoundHistoryFormHistoryTable"
        rows={Array.from(data.keys())}
        columns={LostAndFoundFormHistoryTableColumns}
        row={LostAndFoundFormHistoryTableRow}
      />
    </Provider>
  );
};

export default LostAndFoundFormHistoryTable;
